import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HTTP_CONTEXT } from 'src/app/helper/class/app-constant';
import { downloadHelper } from 'src/app/helper/class/downloadHelper';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { ResponseData } from 'src/app/helper/interface/response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AttendanceApiService {
  urlSegment = environment.payrollUrl;
  constructor(
    private http: HttpClient,
    private downloadHelper: downloadHelper,
  ) {}

  saveLeaveApplication(data: any) {
    return lastValueFrom(
      this.http.post(`${this.urlSegment}/staffleave/applyAndApprove`, data),
    );
  }
  applyLeaveApplication(data: any) {
    return lastValueFrom(
      this.http.post(`${this.urlSegment}/staffleave/apply`, data),
    );
  }

  leaveSyncJob(id: string | number) {
    return lastValueFrom(
      this.http.get(`${this.urlSegment}/syncLeaveStaff/${id}`),
    );
  }
  approveRejectLeave(
    id: any,
    data: any,
    type: 'approve' | 'reject' = 'approve',
  ) {
    return lastValueFrom(
      this.http.post(`${this.urlSegment}/staffleave/${type}/${id}`, data),
    );
  }
  getStaffBasicPayroll(id) {
    return lastValueFrom(
      this.http.get(`${this.urlSegment}/getStaffBasicPayroll/${id}`),
    );
  }

  getSummary(
    id: string | null,
    ev: any,
    type: 'EXPORT' | 'FILTER' = 'FILTER',
  ): any {
    let api: string;
    let method: 'GET' | 'POST' = 'GET';

    if (type === 'EXPORT') {
      api = 'exportSummary';
      method = 'POST';
      ev.export = true;
    } else if (id) {
      api = `showSummary/${id}`;
    } else {
      api = 'getSummaryByCond';
      method = 'POST';
    }

    const url = `${this.urlSegment}/attendance/${api}`;

    // 🔹 EXPORT
    if (type === 'EXPORT') {
      return this.downloadHelper.downloadApi(
        url,
        'POST',
        'Attendance_export',
        ev,
      );
    }

    // 🔹 FILTER (POST)
    if (method === 'POST') {
      return lastValueFrom(
        this.http.post(url, ev, {
          context: new HttpContext().set(HTTP_CONTEXT.SKIP_SUCCESS, true),
        }),
      );
    }

    // 🔹 GET (by id)
    return lastValueFrom(
      this.http.get(url, {
        context: new HttpContext().set(HTTP_CONTEXT.SKIP_SUCCESS, true),
      }),
    );
  }
  exportStats(ev) {
    const url = `${this.urlSegment}/staffleave/exportLeaveStats`;
    return this.downloadHelper.downloadApi(
      url,
      'POST',
      'leave_stats_export',
      ev,
    );
  }
  markComplete(id) {
    return lastValueFrom(
      this.http.get(`${this.urlSegment}/attendance/markComplete/${id}`),
    );
  }
  getAttendanceById(id: any) {
    return lastValueFrom(
      this.http.get(`${this.urlSegment}/attendance/get/${id}`),
    );
  }
  getLeaveByStaff(id: any) {
    return lastValueFrom(
      this.http.get(`${this.urlSegment}/staffleave/balance/${id}`),
    );
  }
  saveAttendance(ev: any) {
    return lastValueFrom(
      this.http.post(`${this.urlSegment}/attendance/save`, ev),
    );
  }
  saveAttendanceList(ev: any) {
    return lastValueFrom(
      this.http.post(`${this.urlSegment}/attendance/saveList`, ev),
    );
  }

  getListAttendance(ev: any, isDelete: boolean = false) {
    const api = isDelete ? 'getListDeleted' : 'getList';
    return lastValueFrom(
      this.http.post(`${this.urlSegment}/attendance/${api}`, ev),
    );
  }
  getListLeaveApplication(ev: any) {
    return lastValueFrom(
      this.http.post(`${this.urlSegment}/staffleave/getList`, ev),
    );
  }
  getListLeaveStats(ev: any) {
    return lastValueFrom(
      this.http.post(`${this.urlSegment}/staffleave/statsList`, ev),
    );
  }

  sentMail(id: any) {
    return lastValueFrom(
      this.http.get(`${this.urlSegment}/staffleave/notifyMail/${id}`),
    );
  }

  getStaffPublicLeaveList(ev: any) {
    return lastValueFrom(
      this.http.post(`${this.urlSegment}/getStaffPublicLeaveList`, ev),
    );
  }
  getLeaveApplicationById(id: any) {
    return lastValueFrom(
      this.http.get(`${this.urlSegment}/staffleave/getById/${id}`),
    );
  }

  getListHoliday(ev: any) {
    return lastValueFrom(
      this.http.post(`${this.urlSegment}/holiday/getList/ACTIVE`, ev),
    );
  }
  getListHolidayByYear(ev: any) {
    return lastValueFrom(
      this.http.post(`${this.urlSegment}/holiday/getHolidayList/ACTIVE`, ev),
    );
  }
  getHoliday(id: any) {
    return lastValueFrom(this.http.get(`${this.urlSegment}/holiday/get/${id}`));
  }
  deleteHoliday(id: any) {
    return lastValueFrom(
      this.http.delete(`${this.urlSegment}/holiday/delete/${id}`),
    );
  }
  saveHoliday(data: any) {
    return lastValueFrom(
      this.http.post(`${this.urlSegment}/holiday/save`, data),
    );
  }
  markPresent(data: any) {
    return lastValueFrom(
      this.http.post(`${this.urlSegment}/attendance/markPresent`, data),
    );
  }
  getPendingList(reportDate: any, ev: any) {
    return lastValueFrom(
      this.http.post(
        `${this.urlSegment}/attendance/getPendingStaff/${reportDate}`,
        ev,
      ),
    );
  }
  getAttendanceInfo(id) {
    return lastValueFrom(
      this.http.get(`${this.urlSegment}/attendance/getInfo/${id}`),
    );
  }

  searchStaff(w: any = {}) {
    return lastValueFrom(this.http.post(`${this.urlSegment}/staffsearch`, w));
  }

  deleteStaffLeave(id: any, data: any) {
    return lastValueFrom(
      this.http.delete(`${this.urlSegment}/staffleave/delete/${id}`, {
        body: data,
      }),
    );
  }

  deleteStaffAttendance(id: any, data: any) {
    return lastValueFrom(
      this.http.delete(`${this.urlSegment}/attendance/delete/${id}`, {
        body: data,
      }),
    );
  }
  deleteStaffAttendanceList(id: any, data: any = {}) {
    return lastValueFrom(
      this.http.delete(`${this.urlSegment}/attendance/deleteList/${id}`, {
        body: data,
      }),
    );
  }

  attendanceRevert(id: any) {
    return lastValueFrom(
      this.http.get(`${this.urlSegment}/attendance/revert/${id}`),
    );
  }
  saveWeekOff(ev: any) {
    return lastValueFrom(this.http.post(`${this.urlSegment}/weekoff/save`, ev));
  }
  deleteWeekOff(id: any, data: any) {
    return lastValueFrom(
      this.http.delete(`${this.urlSegment}/weekoff/delete/${id}`, {
        body: data,
      }),
    );
  }
}
